/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { Container, Row, Col, Card, CardBody, FormGroup, Label, Form, Input, CardTitle, CardSubtitle } from 'reactstrap';
import Select from 'react-select';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import Breadcrumbs from '../../../components/Common/Breadcrumb';
import api from '../../../api';
import { seoUrl } from '../../../utils/seoUrl';
import axios from 'axios';
import TextEditor from '../../../components/TextEditor';
import { getTokenDecoded } from '../../../utils/auth';

function seasonList() {
	const seasons = [];
	for (let i = 2006; i <= 2026; i++) {
		seasons.push({ label: i, value: i });
	}

	return seasons.reverse();
}

const AddTransferBoard = () => {
	const [leagues, setLeagues] = useState();
	const [league, setLeague] = useState();

	const [seasons] = useState(seasonList);
	const [season, setSeason] = useState({ label: 2023, value: 2023 });

	const [teams, setTeams] = useState();
	const [team, setTeam] = useState();

	const [players, setPlayers] = useState();
	const [player, setPlayer] = useState();

	const [age, setAge] = useState();
	const [fee, setFee] = useState();
	const [source, setSource] = useState('');

	// Transfered Data
	const [transferedLeague, setTransferedLeague] = useState();
	const [transferedTeams, setTransferedTeams] = useState();
	const [transferedTeam, setTransferedTeam] = useState();

	// Loaders
	const [playerLoader, setPlayerLoader] = useState(false);
	const [aiLoader, setAILoader] = useState(false);
	const [contentLoader, setContentLoader] = useState(false);

	// AI Content
	const [content, setContent] = useState({});

	const [title, setTitle] = useState();
	const [spot, setSpot] = useState();
	const [detail, setDetail] = useState();
	const [status, setStatus] = useState('Dedikodu');
	const [verification, setVerification] = useState(false);
	const [contentId, setContentId] = useState();
	const [tags, setTags] = useState();

	useEffect(() => {
		api.soccer.leagues().then((res) => {
			if (res && res?.data?.length > 0) {
				setLeagues(
					res.data
						.filter((x) => x.country.name !== 'World')
						.map((item) => ({ label: `[${item?.country?.code}] ${item.name_tr === '' ? item.name : item.name_tr}`, value: item.id, info: item })),
				);
			}
		});
	}, []);

	useEffect(() => {
		if (league) {
			api.soccer.teams(league.value, season.value).then((res) => {
				if (res && res?.data?.length > 0) {
					setTeams(res.data.map((item) => ({ label: item.team.name, value: item.team.id, info: item })));
				}
			});
		}
	}, [league]);

	useEffect(() => {
		if (team) {
			setPlayerLoader(true);

			api.soccer.players(league.value, season.value).then((res) => {
				setPlayerLoader(false);
				if (res && res?.data?.length > 0) {
					setPlayers(
						res.data
							.filter((x) => x.statistics[0]?.team?.id === team.value)
							.map((item) => ({ label: `${item.player.name} - ${seoUrl(item.player.firstname + ' ' + item.player.lastname)}`, value: item.player.id, info: item })),
					);
				}
			});
		}
	}, [team]);

	useEffect(() => {
		if (transferedLeague) {
			api.soccer.teams(transferedLeague.value, season.value).then((res) => {
				if (res && res?.data?.length > 0) {
					setTransferedTeams(res.data.map((item) => ({ label: item.team.name, value: item.team.id, info: item })));
				}
			});
		}
	}, [transferedLeague]);

	useEffect(() => {
		if (player) {
			setAge(player?.info?.player?.age);
		}
	}, [player]);

	async function generateContent(playerName, transferedTeam, team, age, position, minute, lineups, goals, assists, rating, total, won, transferFee) {
		try {
			const openaiApiKey = 'sk-proj-jdVxGWOjle7rvB2JPTN4T3BlbkFJLqcCvfXlxpwgvIsfmLDW';
			const openaiAxiosInstance = axios.create({
				baseURL: 'https://api.openai.com/v1',
				headers: {
					Authorization: `Bearer ${openaiApiKey}`,
					'Content-Type': 'application/json',
				},
			});

			openaiAxiosInstance.interceptors.request.use(
				(config) => {
					config.headers['Authorization'] = `Bearer ${openaiApiKey}`;
					return config;
				},
				(error) => {
					return Promise.reject(error);
				},
			);

			setAILoader(true);

			const response = await openaiAxiosInstance.post('/chat/completions', {
				model: 'gpt-3.5-turbo',
				messages: [
					{ role: 'system', content: 'Sen bir gazetecisin ve haber makaleleri yazıyorsun.' },
					{
						role: 'user',
						content: `${playerName} isimli futbolcunun ${transferedTeam} takımına transferi hakkında bir haber makalesi yaz. Aşağıdaki bilgileri içermeli: ${team} takımdaydı, ${age} yaşında, ${position} mevkide oynuyor, ${minute} dakika oynadı, ${lineups} kez ilk 11'de başladı, ${goals} gol attı, ${assists} asist yaptı, ${rating} ortalamasına sahip, ${total} ikili mücadelenin ${won} tanesini kazandı, bonservis bedeli ${transferFee}. Eğer bu verilerden bazıları sıfır veya undefined geliyorsa o verileri dahil etme. Tüm metni Türkçeleştir. Attacker gibi mevkileri olduğu gibi yazma, Türkçe'sini yaz. Çıktıyı JSON formatında aşağıdaki yapıda ver: title, spot, content.`,
					},
				],
				max_tokens: 1000,
			});

			if (response) setAILoader(false);
			setContentId();

			setContent(JSON.parse(response?.data?.choices[0]?.message?.content));
		} catch (error) {
			console.log(error);
		}
	}

	function contentGenerate() {
		generateContent(
			player?.info?.player?.firstname + ' ' + player?.info?.player?.lastname,
			transferedTeam.label,
			team.label,
			player?.info?.player?.age,
			player?.info?.statistics[0]?.games?.position,
			player?.info?.statistics[0]?.games?.minutes,
			player?.info?.statistics[0]?.games?.lineups,
			player?.info?.statistics[0]?.goals?.total,
			player?.info?.statistics[0]?.goals?.assits,
			player?.info?.statistics[0]?.games?.rating,
			player?.info?.statistics[0]?.duels?.total,
			player?.info?.statistics[0]?.duels?.won,
			fee,
		);
	}

	useEffect(() => {
		if (content) {
			setTitle(content?.title);
			setSpot(content?.spot);
			setDetail(content?.content);
		}
	}, [content]);

	async function saveContent() {
		let newContent = false;
		let tags = [];
		let content = '';

		if (contentId) {
			// only save content Id
		} else {
			// add new content first
			newContent = true;
			content = detail;
			tags = [
				{ TagId: 16, Level: 1, Name: 'Futbol', IsActive: true, IsDeleted: false },
				{ TagId: 18, Level: 1, Name: 'Transfer', IsActive: true, IsDeleted: false },
			];
		}

		const sendObject = {
			player: {
				id: player?.info?.player?.id,
				name: player?.info?.player?.firstname + ' ' + player?.info?.player?.lastname,
				age: player?.info?.player?.age,
				photo: player?.info?.player?.photo,
			},
			teams: {
				current: {
					id: team?.info?.team?.id,
					name: team?.info?.team?.name,
					logo: team?.info?.team?.logo,
					league: {
						id: league?.info?.id,
						name: league?.info?.name_tr,
						logo: league.info?.logo,
					},
				},
				new: {
					id: transferedTeam?.info?.team?.id,
					name: transferedTeam?.info?.team?.name,
					logo: transferedTeam?.info?.team?.logo,
					league: {
						id: transferedLeague?.info?.id,
						name: transferedLeague?.info?.name_tr,
						logo: transferedLeague.info?.logo,
					},
				},
			},
			fee,
			source,
			status,
			verification,
			contentId,
			editor: {
				id: getTokenDecoded(localStorage.ajstoken).UserId,
				name: getTokenDecoded(localStorage.ajstoken).Fullname,
			},
			newContent,
			title,
			spot,
			content,
		};

		setContentLoader(true);

		const save = await api.content.transfer.add(sendObject);

		if (save) {
			setContentLoader(false);

			toastr.options = {
				positionClass: 'toast-top-center',
				progressBar: true,
			};

			if (save.success) {
				toastr.success(save.message);

				setTimeout(() => window.location.reload(), 2000);
			} else {
				toastr.error(save.message);
			}
		}
	}
	('');

	const handleContentIdChange = (e) => {
		const { value } = e.target;
		if (/^\d*$/.test(value) && value.length <= 6) {
			setContentId(parseInt(value, 10));
		}
	};

	async function searchContent() {
		setContentLoader(true);

		if (contentId) {
			const content = await api.content.get(contentId);

			setContentLoader(false);

			if (content) {
				setTitle(content?.content?.Title);
				setSpot(content?.content?.Spot);
				setDetail(content?.content?.GalleryContent?.map((item) => item.Spot).join(' '));
				setTags(content?.content?.TagList);
				setContent(content);
			}
		}
	}

	async function removeSearchContent() {
		setTitle('');
		setSpot('');
		setDetail('');
		setTags('');
		setContentId('');
		setContent({});
	}

	return (
		<>
			<Helmet>
				<title>{`Transfer Ekle - Haber Yönetimi | ${process.env.REACT_APP_TITLE}`}</title>
			</Helmet>
			<div className="page-content form-padding">
				<Container fluid>
					<Breadcrumbs title="Haber Yönetimi" breadcrumbItem="Transfer Ekle" />

					<Row>
						<Col className="col-12">
							<Card>
								<CardBody>
									<div className="d-flex justify-content-between mb-3">
										<div>
											<CardTitle>Oyuncu ve Mevcut Takım Bilgileri</CardTitle>
											<CardSubtitle>
												Transfer olmadan önceki takımını seçin. Örn: Michy Batshuayi Fenerbahçe&apos;den Galatasaray&apos;a gidiyorsa buradaki takım Fenerbahçe olmalı.
											</CardSubtitle>
										</div>
									</div>

									<Row>
										<Col lg="3">
											<FormGroup>
												<Label>Lig</Label>
												<Select value={league} onChange={(e) => setLeague(e)} options={leagues} classNamePrefix="select2-selection" placeholder="Lig seçin" />
											</FormGroup>
										</Col>

										<Col lg="3">
											<FormGroup>
												<Label>Sezon</Label>
												<Select value={season} onChange={(e) => setSeason(e)} options={seasons} classNamePrefix="select2-selection" placeholder="Sezon seçin" />
											</FormGroup>
										</Col>

										<Col lg="3">
											<FormGroup>
												<Label>Takım</Label>
												<Select value={team} onChange={(e) => setTeam(e)} options={teams} classNamePrefix="select2-selection" placeholder="Takım seçin" />
											</FormGroup>
										</Col>

										<Col lg="3">
											<FormGroup>
												<Label>Oyuncu</Label>

												<div className="d-flex flex-row items-center">
													<Select
														value={player}
														onChange={(e) => setPlayer(e)}
														options={players}
														classNamePrefix="select2-selection"
														placeholder="Oyuncu seçin"
														className="w-100"
													/>
													{playerLoader && (
														<span className="mt-2 ml-2">
															<i className="bx bx-loader bx-spin"></i>
														</span>
													)}
												</div>
												<small>Yüklendiği halde Oyuncu bulunamadıysa, soldan tekrar takım seçerek listeyi güncelleyebilirsiniz.</small>
											</FormGroup>
										</Col>
									</Row>
								</CardBody>
							</Card>

							<Card>
								<CardBody>
									<div className="d-flex justify-content-between mb-3">
										<div>
											<CardTitle>Oyuncu ve Transfer Olduğu Takım Bilgileri</CardTitle>
											<CardSubtitle>
												Transfer olduğu takımı seçin. Örn: Michy Batshuayi Fenerbahçe&apos;den Galatasaray&apos;a gidiyorsa buradaki takım Galatasaray olmalı.
											</CardSubtitle>
										</div>
									</div>

									<Row>
										<Col lg="3">
											<FormGroup>
												<Label>Lig</Label>
												<Select
													value={transferedLeague}
													onChange={(e) => setTransferedLeague(e)}
													options={leagues}
													classNamePrefix="select2-selection"
													placeholder="Lig seçin"
												/>
											</FormGroup>
										</Col>

										<Col lg="3">
											<FormGroup>
												<Label>Takım</Label>
												<Select
													value={transferedTeam}
													onChange={(e) => setTransferedTeam(e)}
													options={transferedTeams}
													classNamePrefix="select2-selection"
													placeholder="Takım seçin"
												/>
											</FormGroup>
										</Col>
									</Row>
								</CardBody>
							</Card>

							<Card>
								<CardBody>
									<div className="d-flex justify-content-between mb-3">
										<div>
											<CardTitle>Oyuncu Bilgileri</CardTitle>
										</div>
									</div>
									<Form>
										<Row>
											<Col lg="2">
												<FormGroup>
													<Label>Yaşı</Label>
													<Input name="age" value={age} onChange={(e) => setAge(e.target.value)} />
												</FormGroup>
											</Col>

											<Col lg="2">
												<FormGroup>
													<Label>Bonservis</Label>
													<Input name="fee" value={fee} onChange={(e) => setFee(e.target.value)} />
												</FormGroup>
											</Col>

											<Col lg="3">
												<FormGroup>
													<Label>Kaynak (*)</Label>
													<Input name="source" value={source} onChange={(e) => setSource(e.target.value)} />
												</FormGroup>
											</Col>

											<Col lg="3">
												<FormGroup>
													<Label>Durumu</Label>

													<div className="d-flex flex-row">
														<div className="custom-control custom-radio mr-3">
															<input
																type="radio"
																id="transfer-status"
																name="customRadio"
																className="custom-control-input"
																onChange={() => setStatus('Dedikodu')}
																checked={status === 'Dedikodu'}
															/>
															<label className="custom-control-label" htmlFor="transfer-status">
																Dedikodu
															</label>
														</div>
														<div className="custom-control custom-radio">
															<input
																type="radio"
																id="getransfer-status"
																name="customRadio"
																className="custom-control-input"
																onChange={() => setStatus('Resmi')}
																checked={status === 'Resmi'}
															/>
															<label className="custom-control-label" htmlFor="getransfer-status">
																Resmi
															</label>
														</div>
													</div>
												</FormGroup>
											</Col>

											<Col lg="2">
												<FormGroup>
													<Label>Doğrulama</Label>

													<div className="custom-control custom-checkbox">
														<input
															type="checkbox"
															className="custom-control-input"
															id="verification"
															name="verification"
															onChange={() => setVerification(!verification)}
															value={verification}
															checked={verification}
														/>
														<label className="custom-control-label" htmlFor="verification">
															Doğrulandı
														</label>
													</div>
												</FormGroup>
											</Col>
										</Row>
									</Form>
								</CardBody>
							</Card>

							<Card>
								<CardBody>
									<div className="d-flex flex-row mb-3">
										<button type="button" onClick={contentGenerate} className="btn btn-primary" disabled={aiLoader}>
											{aiLoader && <i className="bx bx-loader bx-spin"></i>} Haber{Object.keys(content).length > 0 && 'i Yeniden'} Üret
										</button>

										<button type="button" onClick={saveContent} className="btn btn-primary ml-2" disabled={Object.keys(content).length <= 0 || contentLoader}>
											{contentLoader && <i className="bx bx-loader bx-spin"></i>} Haberi Kaydet
										</button>

										<Col lg="5" className="ml-auto d-flex flex-row">
											<Input type="number" placeholder="Haber Ara (ID ile)" className="mt-2" value={contentId} onChange={handleContentIdChange} />
											<button className="btn btn-secondary btn-sm ml-2" onClick={searchContent}>
												Ara
											</button>

											<button className="btn btn-secondary btn-sm ml-2" onClick={removeSearchContent}>
												Temizle
											</button>
										</Col>
									</div>

									<Row>
										<Col lg="12">
											<FormGroup>
												<Label>Haber Başlığı</Label>
												<Input type="text" value={title} onChange={(e) => setTitle(e.target.value)} disabled={contentId} />
											</FormGroup>
										</Col>

										<Col lg="12">
											<FormGroup>
												<Label>Haber Spot</Label>
												<textarea className="form-control" value={spot} onChange={(e) => setSpot(e.target.value)} disabled={contentId}></textarea>
											</FormGroup>
										</Col>

										<Col lg="12">
											<FormGroup>
												<Label>Haber</Label>
												<TextEditor id="body" name="Body" onChange={(text) => setDetail(text)} value={detail} disabled={contentId} />
											</FormGroup>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		</>
	);
};

export default AddTransferBoard;
